import type { Environment } from '../../environments/environment.interface';

export const isSafeRedirectUrl = (url: string, appConfig: Environment) => {
    const safePrefixs = [appConfig.platform_url, appConfig.website_url];
    const decodedUrl = decodeURIComponent(url);
    return safePrefixs.some((safePrefix) => decodedUrl.indexOf(safePrefix) === 0);
};
